if (!customElements.get('home-hero-slideshow')) {
  customElements.define(
    'home-hero-slideshow',
    class HomeHeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.current = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active'))
        );
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = false;

        this.onDotClick = (event) => this.goTo(Number(event.currentTarget.dataset.dot), true);
        this.onPause = () => this.stop();
        this.onResume = () => this.start();
        this.onBlockSelect = (event) => {
          const index = this.slides.indexOf(event.target);
          if (index > -1) {
            this.goTo(index, true);
            this.stop();
          }
        };
        this.onBlockDeselect = () => this.start();
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());

        this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
        this.addEventListener('mouseenter', this.onPause);
        this.addEventListener('mouseleave', this.onResume);
        this.addEventListener('focusin', this.onPause);
        this.addEventListener('focusout', this.onResume);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      get shouldAutoplay() {
        return this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reducedMotion;
      }

      start() {
        this.stop();
        if (!this.shouldAutoplay) return;
        const seconds = Number(this.dataset.speed) || 6;
        this.timer = setInterval(() => this.goTo(this.current + 1), seconds * 1000);
      }

      stop() {
        clearInterval(this.timer);
      }

      goTo(index, restart) {
        const next = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === next;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, i) => {
          const active = i === next;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        this.current = next;
        if (restart) this.start();
      }
    }
  );
}
